import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
// import * as Icon from "@ant-design/icons";
import * as Icon  from 'lucide-react'
import dashboardRoutes from "../../routes/DashboardRoutes";
import NavButton from "../common/NavButton";
import './menu.less'

const SideMenu = ({ menu = [], collapsed = false }) => {
  const { pathname = "" } = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  const getPathCode = () => {
    const route = dashboardRoutes?.find?.((route) => route.path === pathname);
    if (route?.code) {
      return route.code;
    }
    return null;
  };

  const pathCode = getPathCode();

  useEffect(() => {
    // setOpenKeys(getDefaultOpenKeys());
    setOpenKeys(getOpenRouteCodes(dashboardRoutes, pathCode));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu, pathname, pathCode]);

  const generateIcon = (name) => {
    return React.createElement(Icon?.[name] ?? Icon.LayoutDashboard, {
      style: { width:20 , height:20},
    });
  };

  const getOpenRouteCodes = (array, code, codes = []) => {
    const updatedCodes = [...codes, code];
    const route = array.find((item) => item.code === code);
    if (route?.parent) {
      return getOpenRouteCodes(array, route.parent, updatedCodes);
    }
    return updatedCodes;
  };

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  // const getOpenKeysRecursively = (array) => {
  //     let keys = [];
  //     for (const item of array) {
  //         if (item.code === pathCode) {
  //             return [pathCode];
  //         } else {
  //             if (item?.children?.length) {
  //                 const childKeys = getOpenKeysRecursively(item.children)

  //                 if (childKeys.length > 0) {
  //                     return [...keys, item.code, ...childKeys];
  //                 }
  //             }
  //         }
  //     }
  //     return keys;
  // }

  // const getDefaultOpenKeys = () => {
  //     if (pathCode && dashboardRoutes?.length) {
  //         return getOpenKeysRecursively(menu);
  //     }
  //     return [];
  // };

  const getMenuItems = () => {
    return (menu || []).map((item) => {
      const dashboardRouteObject = dashboardRoutes.find(
        (dr) => dr.code === item.code
      );
      let path = "";
      if (dashboardRouteObject?.path) {
        path = dashboardRouteObject.path;
      } else {
        path = item.path ?? "";
      }
      let children = [];
      if (item.children) {
        children = item.children.map((subItem) => {
          const subRoute = dashboardRoutes.find(
            (dr) => dr.code === subItem.code
          );
          let subPath = "";
          if (subRoute?.path) {
            subPath = subRoute.path;
          } else {
            subPath = subItem.path ?? "";
          }
          return {
            key: subItem.code,
            icon: generateIcon(subItem.icon),
            label: <Link to={subPath}>{subItem.name}</Link>,
          };
        });
      }

      if (children.length) {
        return {
          key: item.code,
          icon: generateIcon(item.icon),
          label: item.name,
          children,
        };
      }

      return {
        key: item.code,
        icon: generateIcon(item.icon),
        label: <Link to={path}>{item.name}</Link>,
      };
    });
  };

  return (
    <div className="menu_container">
      <NavButton collapsed={collapsed} />
      <Menu
        className="menu"
        selectedKeys={openKeys}
        openKeys={openKeys}
        mode="inline"
        theme="light"
        style={{ border: "none"}}
        onOpenChange={handleOpenChange}
        items={getMenuItems()}
      />
    </div>
  );
};

export default SideMenu;
